import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../../../API/apiClient ";

export const GetPoData = createAsyncThunk(
  'ProductionFg/GetPoData',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiClient.get('ProductionFg/GetPoData');
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching Po Data');
    }
  }
);

// export const GetPoReceipt = createAsyncThunk(
//   'ProductionFg/GetPoReceipt',
//   async ({DocEntry}, { rejectWithValue }) => {
//     try {
//       const response = await apiClient.get(`ProductionFg/GetPoReceipt?DocEntry=${DocEntry}`);
//       return response.data;  
//     } catch (error) {
//       return rejectWithValue(error.response?.data || 'Error fetching Po Receipt');
//     }
//   }
// );
export const GetTransaction = createAsyncThunk(
  'ProductionFg/GetPoReceipt',
  async ({DocEntry}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`ProductionFg/GetPoNumTransaction?DocEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching Po Receipt');
    }
  }
);

export const GetPOINVPINPUT = createAsyncThunk(
  'ProductionFg/POINVPINPUT',
  async ({DocEntry}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`ProductionFg/GetPOINVPINPUT?DocEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const GETPRODISSUE = createAsyncThunk(
  'ProductionFg/PRODISSUE',
  async ({DocEntry}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`ProductionFg/GETPRODISSUE?DocEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const GETPRODRECEIPT = createAsyncThunk(
  'ProductionFg/PRODReceipt',
  async ({DocEntry}, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(`ProductionFg/GETPRODRECEIPT?DocEntry=${DocEntry}`);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const PostPOINVPINPUT = createAsyncThunk(
  'ProductionFg/POSTInvData',
  async (tableBody, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(`ProductionFg/PostFgProductionIP`, tableBody);
      return response.data;  
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const postProductionFGReceipt = createAsyncThunk(
  'ProductionFg/ProductionReceipt',  // Action name for redux
  async (dataToPost, { rejectWithValue }) => {
    try {
      // Make the POST request with updatedRows as the payload
      const response = await apiClient.post('ProductionFg/PostFgProductionReceipt', dataToPost);
      return response.data;  // Return the response data to be stored in Redux
    } catch (error) {
      // Handle the error and return it with rejectWithValue for better error handling
      return rejectWithValue(error.response?.data);
    }
  }
);
